module.exports = __webpack_public_path__ + "static/image/service/font.ver2_0_2.jpg?aa79292a";